import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { SWRConfig } from 'swr'
import { AdminAuthProvider } from './admin/AdminAuthContext'
import { AuthProvider } from './auth/AuthContext'
import { PackageCatalogProvider } from './components/auth/PackageCatalogContext'
import App from './App'
import './index.css'

const root = document.getElementById('root')
if (!root) throw new Error('Missing #root')

createRoot(root).render(
  <StrictMode>
    <BrowserRouter>
      <SWRConfig
        value={{
          revalidateOnFocus: false,
          shouldRetryOnError: false,
        }}
      >
        <PackageCatalogProvider>
          <AuthProvider>
            <AdminAuthProvider>
              <App />
            </AdminAuthProvider>
          </AuthProvider>
        </PackageCatalogProvider>
      </SWRConfig>
    </BrowserRouter>
  </StrictMode>,
)
